<template>
  <TimingParameters />
</template>

<script setup lang="ts">
import TimingParameters from "./TimingParameters.vue"
</script>